import { render, staticRenderFns } from "./EstoqueOrdemCompra.vue?vue&type=template&id=4c4409cd&"
import script from "./EstoqueOrdemCompra.vue?vue&type=script&lang=js&"
export * from "./EstoqueOrdemCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports